// @ts-nocheck adb539ed
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_Hmenu'],
      sections: [addPanel.sections.getSections().menu.horizontalMenusSection],
    };
  },
};
